import React from "react";
import { VerificationForm, VerificationImage } from "./component/index";
import { Row, Col } from "react-bootstrap";

const Verification = () => {
  return (
    <>
      <div className="wrapper">
        <div className="vh-100">
          <Row>
            <Col lg={6}>
              <VerificationForm />
            </Col>
            <Col lg={6}>
              <VerificationImage />
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default Verification;
